<template>
  <div class="con">
    <div class="banner">
      <div style="width: 1200px;position: relative;display: flex;justify-content: space-between;align-items: center;">
        <p class="top-title">{{ topTitle }}</p>
        <!-- <el-dropdown v-if="$store.state.name" @command="handleCommand">
          <div class="el-dropdown-link" style="display: flex;flex-wrap: wrap;width: 67px;cursor: pointer;">
            <img src="../../assets/img/user_icon.png" alt="" srcset="">
            <span style="color:#fff;display: inline-block;width: 67px;">个人中心</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="clearfix" command="Personal">
              {{ $store.state.name }}
            </el-dropdown-item>
            <el-dropdown-item class="clearfix" command="LoginOut">
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown v-else trigger="click" class="userMenu" disabled>
          <div class="el-dropdown-link" style="display: flex;flex-wrap: wrap;width: 67px;cursor: pointer;">
            <img src="../../assets/img/user_icon.png" alt="" srcset="">
            <span style="color:#fff;display: inline-block;width: 67px;" @click="toWeiXinLogin">登录</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="clearfix">
            </el-dropdown-item>
            <el-dropdown-item class="clearfix">
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
    </div>
    <div class="cont">
      <div class="tab-box">
        <el-button size="medium" :class="{ activeButton: activeName == '1' }" @click="changeTab('1')">按生命周期</el-button>
        <el-button size="medium" v-show="topTitle == '汉源县政务服务中心'" style="width: 111.6px;"
          :class="{ activeButton: activeName == '2' }" @click="changeTab('2')">按部门</el-button>
      </div>
      <!-- <el-button type="text" class="text_btn" :class="{ active_textButton: activeServiceType == '1' }" @click="handleClick('1')">个人服务</el-button>
        <el-button type="text" class="text_btn" :class="{ active_textButton: activeServiceType == '2' }" @click="handleClick('2')">法人服务</el-button> -->
      <el-tabs v-show="activeName == '1'" v-model="activeServiceType" @tab-click="handleClick">
        <el-tab-pane label="个人服务" name="1">
          <div class="list">
            <div class="list-item" v-for="(item, index) in PersonalServiceList" :key="index"
              @click="toLifeCycle(item, '1')">
              <img :src="setBgColor(item.name)" alt="" width="40px;" height="auto">
              <span style="color:#000">{{ item.name }}</span>
            </div>
          </div>
          <!-- <el-row :gutter="20">
            <el-col :span="6"  v-for="(item, index) in PersonalServiceList" :key="index">
              <img :src="setBgColor(item.name)" width="40px" alt="">
              <span style="color:#000">{{item.name}}</span>
            </el-col>
          </el-row> -->
        </el-tab-pane>
        <el-tab-pane label="法人服务" name="2">
          <div class="list">
            <div class="list-item" v-for="(item, index) in CorporateServicesList" @click="toLifeCycle(item, '2')"
              :key="index">
              <img :src="setBgColor(item.name)" alt="" width="40px;" height="auto">
              <span style="color:#000">{{ item.name }}</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="dept_list" v-show="activeName == '2'">
        <div class="dept_list_item" v-for="(item, index) in deptList" :key="index" @click="toLifeCycle(item, '3')">
          {{ item.deptName }}
        </div>
      </div>
      <!-- <div class="list" v-show="activeName == '1'">
        <div :style="setBgColor(item.name)" class="list-item" v-for="(item, index) in PersonalServiceList" :key="index">
          <a class="list-item-title" @click="toLifeCycle(item.lifeCycleId, item.name, '1')">{{ item.name }}</a>
          <ul>
            <li v-for="(it, index) in item.matters" :key="index">
              <span class="li-circle"></span>
              <a style="color:#fff;cursor: pointer;" @click="toDetail(it.deptMatterId, it.name)">{{ it.name }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="list" v-show="activeName == '2'">
        <div :style="setBgColor(item.name)" class="list-item" v-for="(item, index) in CorporateServicesList"
          :key="index">
          <a class="list-item-title" @click="toLifeCycle(item.lifeCycleId, item.name, '2')">{{ item.name }}</a>
          <ul>
            <li v-for="(it, index) in item.matters" :key="index">
              <span class="li-circle"></span>
              <a style="color:#fff;cursor: pointer;" @click="toDetail(it.deptMatterId, it.name)">{{ it.name }}</a>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { lifeCycleMatter, GetdeptList, doLogin } from "@/api/map/index";
import { logout } from "@/api/user/index";
export default {
  name: 'Disclosure',
  components: {},
  data() {
    return {
      topTitle: this.$route.params.topTitle,
      deptId: this.$route.params.deptId,
      id: this.$route.params.id,
      activeName: "1",
      activeServiceType: '1',
      name: this.$store.state.name,  //当前登录用户名
      // lifeCycleList: [], //生命周期列表
      PersonalServiceList: [],   //个人服务列表
      CorporateServicesList: [], //法人服务列表
      itemImg: {
        '其他': require('../../assets/img/qt.png'),
        '工作': require('../../assets/img/work.png'),
        '升学': require('../../assets/img/sx.png'),
        '购房': require('../../assets/img/gf.png'),
        '结婚': require('../../assets/img/jh.png'),
        '生育': require('../../assets/img/shengy.png'),
        '失业': require('../../assets/img/sy.png'),
        '创业': require('../../assets/img/cy.png'),
        '迁居': require('../../assets/img/qj.png'),
        '退休': require('../../assets/img/tx.png'),
        '后事': require('../../assets/img/hs.png'),
        '开办企业': require('../../assets/img/kbqy.png'),
        '申请资质': require('../../assets/img/sqzz.png'),
        '投资立项': require('../../assets/img/tzlx.png'),
        '扩大生产': require('../../assets/img/kdsc.png'),
        '引进人才': require('../../assets/img/yjrc.png'),
        '办理社保': require('../../assets/img/blsb.png'),
        '申请专利': require('../../assets/img/sqzl.png'),
        '缴纳税费': require('../../assets/img/jnsf.png'),
        '申请贷款': require('../../assets/img/sqdk.png'),
        '申请破产': require('../../assets/img/sqpc.png'),
      },
      deptList: [],  //部门列表
    };
  },

  mounted() {
    if (sessionStorage.getItem("topTitle")) {
      this.topTitle = sessionStorage.getItem("topTitle");
    }
    // if (sessionStorage.getItem("deptObj")) {
    //   this.deptId = JSON.parse(sessionStorage.getItem("deptObj")).deptId;
    //   this.id = JSON.parse(sessionStorage.getItem("deptObj")).id;
    // }
    // 每次进入手动刷新页面，更新登录状态
    // if (location.href.indexOf("#reloaded") == -1) {
    //   location.href = location.href + "#reloaded";
    //   location.reload();
    // }
    this.getPersonalServices();
  },
  computed: {
  },
  methods: {
    // 获取个人服务列表
    getPersonalServices() {
      let params = {
        serviceTypeId: '1',
        deptId: this.deptId,
      }
      lifeCycleMatter(params).then((res) => {
        if (res.data.code == 200 && res.data.data.length > 0) {
          this.PersonalServiceList = res.data.data;
          // console.log(res,this.PersonalServiceList,'@@')
          // 每个生命周期事项只展示4个，先删除多余事项
          for (let index = 0; index < this.PersonalServiceList.length; index++) {
            if (this.PersonalServiceList[index].matters.length > 0) {
              this.PersonalServiceList[index].matters.splice(4);
            }
          };
          let obj = this.PersonalServiceList[0];
          this.PersonalServiceList.splice(0, 1);
          this.PersonalServiceList.push(obj)
        }
      })
      // this.getmatterQuery(params);
      // for (let index = 0; index < list.length; index++) {
      //   array.forEach(el => {
      //     if (list[index].lifeCycleId.indexOf(el.lifeCycleId.toString()) != -1) {
      //       list[index].name = el.fname;
      //     }
      //   });
      // }
    },
    // 获取法人服务列表
    getCorporateservices() {
      let params = {
        serviceTypeId: '2',
        deptId: this.deptId,
      }
      lifeCycleMatter(params).then((res) => {
        if (res.data.code == 200 && res.data.data.length > 0) {
          this.CorporateServicesList = res.data.data;
          // 每个生命周期事项只展示4个，先删除多余事项
          for (let index = 0; index < this.CorporateServicesList.length; index++) {
            if (this.CorporateServicesList[index].matters.length > 0) {
              this.CorporateServicesList[index].matters.splice(4);
            }
          };
          let obj = this.CorporateServicesList[0];
          this.CorporateServicesList.splice(0, 1);
          this.CorporateServicesList.push(obj)
        }
      })
      // this.getmatterQuery(params);
    },
    // 获取部门列表
    GetdeptList() {
      GetdeptList().then((res) => {
        // console.log(res, '部门列表')
        if (res.data.data && res.data.data.length > 0) {
          this.deptList = res.data.data;
        }
      })
    },
    // 按生命周期/部门
    changeTab(val) {
      if (val == '1') {
        this.getPersonalServices();
        this.activeName = '1';
        this.activeServiceType = '1';
      } else {  //查部门
        this.activeName = '2';
        this.GetdeptList();
        // this.activeServiceType = '1';
      }
    },
    // 个人服务/法人服务切换
    handleClick(val) {
      if (val == '1') {
        this.getPersonalServices();
        this.activeName = '1';
        this.activeServiceType = '1';
      } else {
        this.getCorporateservices();
        this.activeName = '1';
        this.activeServiceType = '1';
      }
    },
    // 事项详情页
    toDetail(id, name) {
      let obj = { deptMatterId: id, name };
      this.$router.push({
        name: "ServiceGuide",
        params: { deptMatterId: id, name }
      });
      sessionStorage.setItem('matterDetails', JSON.stringify(obj));
    },
    // 生命周期详情页
    toLifeCycle(item, type) {
      // this.$router.push({
      //   name: "LifeCycle",
      //   query: { lifeCycleId: id, name: name, serviceTypeId: type }
      // })
      if (type == '1' || type == '2') {
        let obj = { lifeCycleId: item.lifeCycleId, name: item.name, serviceTypeId: type, deptId: this.deptId, id: this.id, };
        this.$router.push({
          name: "LifeCycle",
          params: { lifeCycleId: item.lifeCycleId, name: item.name, serviceTypeId: type, deptId: this.deptId, id: this.id }
        });
        sessionStorage.setItem('lifeCycleDetails', JSON.stringify(obj));
      } else {//根据部门查询
        let obj = { lifeCycleId: item.lifeCycleId, name: item.deptName, serviceTypeId: '', deptId: item.deptId };
        this.$router.push({
          name: "LifeCycle",
          params: { lifeCycleId: item.lifeCycleId, name: item.deptName, serviceTypeId: '', deptId: item.deptId }
        });
        sessionStorage.setItem('lifeCycleDetails', JSON.stringify(obj));
      }
      sessionStorage.setItem('topTitle', this.topTitle)
    },
    // 用户下拉菜单
    handleCommand(name) {
      switch (name) {
        case 'Personal':
          this.$router.push({
            name: 'Personal'
          })
          break;
        case 'LoginOut':
          this.LoginOut()
          break;
      }
    },
    // 退出登录
    LoginOut() {
      let params = {
        userId: JSON.parse(localStorage.getItem('userInfo')).userId,
        token: localStorage.getItem('token').toString(),
      }
      logout(params).then((res) => {
        console.log('退出登录结果：', res)
        if (res.data.code == 200) {
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        } else if (res.data.code == 1001) {
          this.$message.error('登录状态已过期，请重新登录！')
          localStorage.removeItem('userInfo');
          localStorage.removeItem('token');
          sessionStorage.removeItem('applyId');
          this.$router.push('/')
        }
        else {
          this.$message.error('退出登录失败！')
        }
      })
    },
    // 设置每项生命周期背景颜色
    setBgColor(name) {
      switch (name) {
        case '其他':
          return this.itemImg['其他']
          break;
        case '工作':
          return this.itemImg['工作']
          break;
        case '开办企业':
          return this.itemImg['开办企业']
          break;
        case '投资立项':
          return this.itemImg['投资立项']
          break;
        case '申请资质':
          return this.itemImg['申请资质']
          break;
        case '升学':
          return this.itemImg['升学']
          break;
        case '购房':
          return this.itemImg['购房']
          break;
        case '结婚':
          return this.itemImg['结婚']
          break;
        case '生育':
          return this.itemImg['生育']
          break;
        case '失业':
          return this.itemImg['失业']
          break;
        case '创业':
          return this.itemImg['创业']
          break;
        case '迁居':
          return this.itemImg['迁居']
          break;
        case '退休':
          return this.itemImg['退休']
          break;
        case '后事':
          return this.itemImg['后事']
          break;
        case '扩大生产':
          return this.itemImg['扩大生产']
          break;
        case '引进人才':
          return this.itemImg['引进人才']
          break;
        case '办理社保':
          return this.itemImg['办理社保']
          break;
        case '申请专利':
          return this.itemImg['申请专利']
          break;
        case '缴纳税费':
          return this.itemImg['缴纳税费']
        case '申请贷款':
          return this.itemImg['申请贷款']
          break;
        case '申请破产':
          return this.itemImg['申请破产']
          break;
        default:
          break;
      }
      // if (bgColor === '' || bgColor === '' || bgColor === undefined) {
      //   return { background: 'url(' + this.topImg['top_2'] + ')' }
      // } else {
      //   return { background: 'url(' + this.topImg[bgColor] + ')' }
      // }
    },
    // 到微信登录
    toWeiXinLogin() {
      this.$router.push({
        name: "WeiXinLogin",
        replace: true,
      });
    },
  },
  created() {
    this.$emit('public_header', true);
    this.$emit('public_footer', true);
  },
};
</script>
<style
 scoped>
 .banner {
   height: 155px;
   background-size: 100% auto;
   position: absolute;
   top: 150px;
 }

 .con {
   width: 1200px;
   margin: 0 auto;
   margin-top: 20px;
 }

 .userMenu {
   position: initial;
 }

 .top-title {
   font-size: 40px;
   color: #fff;
   font-weight: bold;
   text-align: left;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   width: 75%;
 }


 .tab-box {
   text-align: left;
   padding-bottom: 15px;
   border-bottom: 1px solid #E2E2E2;
 }

 .btn {
   color: #3CA4EC;
   border: 1px solid #A7D4F5;
 }

 .text_btn {
   color: #A2A2A2;
 }

 .activeButton {
   background-color: #31A9FF;
   color: #fff;
 }

 .active_textButton {
   color: #31A9FF
 }

 .list {
   display: flex;
   flex-wrap: wrap;
   margin: 15px 5px;
   color: #fff;
 }

 .list-item {
   /*background: url('../../assets/img/shengyu.png');*/
   width: 265px;
   height: 80px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 0 35px;
   box-sizing: border-box;
   color: #fff;
   margin: 0 32px 30px 0;
   box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
   cursor: pointer;
 }

 .dept_list {
   display: flex;
   flex-wrap: wrap;
   margin-top: 20px;
 }

 .dept_list .dept_list_item {
   width: 200px;
   height: 50px;
   box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
   text-align: center;
   margin: 0 20px 20px 0;
   line-height: 50px;
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
   padding: 0 10px;
   box-sizing: border-box;
   cursor: pointer;
 }

 .list-item .list-item-title,
 .list-item ul>li {
   margin: 15px 0;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
 }

 .list-item .list-item-title {
   font-size: 20px;
   color: #fff;
   cursor: pointer;
 }

 .li-circle {
   width: 6px;
   height: 6px;
   background-color: #fff;
   display: inline-block;
   border-radius: 50%;
   margin-right: 5px;
   margin-bottom: 3px;
 }
</style>
